import { LanguageListItem as LanguageListItemComponent } from '@gisce/oficina-virtual-components';
import useLangs from '@/languages/hooks/useLangs';

export const LanguageListItem = () => {
  const { availableLangsData, currentLangData, changeLang } = useLangs();

  return (
    <LanguageListItemComponent 
      availableLanguages={availableLangsData}
      currentLanguage={currentLangData}
      handleLanguageSelect={(langData) => changeLang(langData.value)}
    />
  );
}